module.exports = __webpack_public_path__ + "img/xr1_detail.092e27c3.jpg";